export const colors = {
    verde_brocoli: "46, 81, 56",
    verde_acelga: "97, 109, 56",
    azul_agua: "7, 135, 137",
    marron_tierra: "81, 62, 46",
    naranja_pimiento: "212, 77, 28",
    amarillo_banana: "226, 167, 48",
    blanco_huevo: "240, 236, 201",
    trebol: "48, 152, 55"
}

export const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export const getProductParticipant = (products, completed) => {
    console.log("completed", completed)

    let pendings = [];
    const participants = products.filter(prod => prod.participant === true);

    products.map(prod => {
        if(!completed.includes(prod.id)){
            if(prod.participant){
                pendings.push(prod.title);
            }
        }
    })
    //const left = products.filter(prod => prod.participant !== true);

    return {complete: pendings.length ? false : true, total: participants.length, pendings: pendings.join(", ")};

}

export const checkQuizWin = (quiz, answers) => {

    let count = 0;
    quiz.questions.map(question => {
        if(question.type !== "survey"){
            answers.map(ans => {
                if(question.id === ans.question_id){
                    let correct_id = "";
                    const correct = question.answers.filter(a => a.correct === 1);
                    if(correct.length){
                        correct_id = correct[0].id;
                    }

                    console.log(ans.answers[0] +"==="+ correct_id);
                    if(ans.answers[0] === correct_id){
                        count++;
                    }
                    console.log("answer", question.id, ans.question_id, question.answers, ans.answers[0], correct);
                }
            })
        }else{
            count++;
        }
    })

    if(quiz.questions.length === count){
        return true;
    }else{
        return false;
    }

}

export const getBadAnswers = (quiz, answers) => {
    //console.log("quiz", quiz)
    //console.log("answers", answers)
    let correct_answerds = []

   

    answers.map(ans => {

        let q_type = "";
        const question_data = quiz.questions.filter(q => q.id === ans.question_id);
        if(question_data.length){
            q_type = question_data[0].type;
        }
        //console.log("q_type", q_type)

        const question_filtered = quiz.questions.filter(question => question.id === ans.question_id);
        switch (q_type) {
            case "single":
                
                if(question_filtered.length){
                    const answer_filtered = question_filtered[0].answers.filter(qans => qans.id === ans.answers[0]);
                    if(answer_filtered.length){
                        
                        if(!answer_filtered[0].correct){
                            const answer_correct = question_filtered[0].answers.filter(qans => qans.correct === 1);
                            if(answer_correct.length){
                                correct_answerds.push({question: question_filtered[0], correct: answer_correct[0]})
                                //console.log("answer_correct", answer_correct[0])
                            }
                        }
                    }
                }

                break;
            case "multi":
                
                if(question_filtered.length){
                    
                    let corrected_list = [];
                    const corrects = question_filtered[0].answers.filter(a => a.correct === 1);
                    //console.log("question_filtered[0].answers", question_filtered[0].answers, ans.answers, corrects);
                    
                    if(corrects.length){
                        corrects.map(c => {
                            console.log(c.id, " **** ", ans.answers, ans.answers.includes(c.id))
                            if(!ans.answers.includes(c.id)){
                                corrected_list.push(c);
                            }
                        })
                    }

                    correct_answerds.push({question: question_filtered[0], correct: corrected_list})
                    
                    //console.log("corrected_list", corrected_list)
                    /*
                    let corrects = [];
                    question_filtered[0].answers.map(ans => {
                        console.log("ans:::", ans, answers)
                        
                        answers.map(a => {
                            console.log("XXXXXX", ans.id, a)
                        })
                        
                    })
                    */

                    /*
                    const answer_filtered = question_filtered[0].answers.filter(qans => qans.id === ans.answers[0]);
                    if(answer_filtered.length){
                        
                        if(!answer_filtered[0].correct){
                            const answer_correct = question_filtered[0].answers.filter(qans => qans.correct === 1);
                            if(answer_correct.length){
                                correct_answerds.push({question: question_filtered[0], correct: answer_correct[0]})
                                console.log("answer_correct", answer_correct[0])
                            }
                        }
                    }
                    */

                }

                break;
            case "survey":
                break;
            default:
                break;
        }
        
    })
    //console.log("correct_answerds", correct_answerds)
    return correct_answerds;

}